var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportNew = function SvgSupportNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2550"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.18a1.3 1.3 0 0 1 1.3 1.3v6.058a1.3 1.3 0 0 1-2.6 0V12.48a1.3 1.3 0 0 1 1.3-1.3M13 9.412a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25"
  }))));
};
export default SvgSupportNew;